import React from 'react';
import Title from '../../components/Title';
import Subtitle from '../../components/Subtitle';
import hero4Desktop from './assets/hero4-desktop.png';

const Benefit = () => (
  <section className="bg-[#efeae7] py-0" id="relacionamento">
    <div className="max-w-[1300px] w-full px-5 lg:px-0 mx-auto">
      <div className="flex justify-center items-start flex-col-reverse lg:flex-row mb-0">
        <img
          src={hero4Desktop}
          alt="Usuária utilizando o app Multi"
          className="max-w-full h-auto md:max-w-none lg:max-w-[600px] xl:max-w-[800px]"
        />

        <div className="flex flex-col pt-20">
          <Title className="text-center md:text-left">Transforme suas compras em pontos e troque por benefícios</Title>
          <Subtitle className="max-w-3xl mx-auto mt-8">
            O Multi tem um programa de relacionamento que oferece mais e melhores vantagens conforme o uso. Você
            cadastra suas notas fiscais no aplicativo e acumula pontos para trocar por benefícios em lojas, gastronomia
            e lazer nos shoppings.
            <br />
            <br />
            Consulte as vantagens disponíveis no seu shopping favorito.
          </Subtitle>
        </div>
        {/* Illustrative image */}
      </div>
    </div>
  </section>
);

export default Benefit;
